import config from '../Config';
import RequestRateLimiter from './RequestRateLimiter';

const requestRateLimiter = new RequestRateLimiter();

const isPermitted = (authToken) => {
  if (process.env.REACT_APP_ENV === 'dev') {
    return true;
  }

  return requestRateLimiter.request(`${config.VDNS_API_URL}/ping`, {
    headers: {
      'Authorization': `Bearer ${authToken}`
    }
  })
    .then(res => Promise.resolve(res.status === 200))
    .catch(() => Promise.resolve(false));
};

const createRecord = (idToken, record) => {
  return requestRateLimiter.request(`${config.VDNS_API_URL}/records`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`
    },
    body: JSON.stringify(record)
  }).then(res => res.json());
};

const getAllRecords = (idToken, params) => {
  const {
    page = 1,
    limit = 10,
    search,
    filters,
  } = params;
  
  return requestRateLimiter.request(`${config.VDNS_API_URL}/records?`
    + `page=${page}`
    + `&limit=${limit}`
    + `${search ? `&search=${search}` : ''}`
    //  Maaaaagic code to convert an array of strings into a comma separated string.
    + `${filters ? `&filters=${Array.prototype.map.call(filters.type, s => s).toString()}` : ''}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${idToken}`
    }
  }).then(res => res.json());
};

const getRecord = (idToken, recordId) => {
  return requestRateLimiter.request(`${config.VDNS_API_URL}/records/${recordId}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${idToken}`
    }
  }).then(res => res.json());
};

const updateRecord = (idToken, updatedRecord) => {
  return requestRateLimiter.request(`${config.VDNS_API_URL}/records/${updatedRecord.id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`
    },
    body: JSON.stringify(updatedRecord)
  }).then(res => res.json());
};

const deleteRecord = (idToken, recordId) => {
  return requestRateLimiter.request(`${config.VDNS_API_URL}/records/${recordId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${idToken}`
    }
  });
};

const getAccountRecords = (idToken, accountId) => {
  // The api endpoint is the same for getting a single
  // record and all records belonging to an account -- checked server side.
  // i.e. /records/:recordId & /records/:accountId
  // Maybe add a check to see if accountId is an accountId and not a recordId?
  getRecord(idToken, accountId);
};

const getAllServices = (idToken) => {
  return requestRateLimiter.request(`${config.VDNS_API_URL}/services`, {
    headers: {
      'Authorization': `Bearer ${idToken}`
    }
  }).then(res => res.json());
};

const getService = (idToken, serviceId) => {
  return requestRateLimiter.request(`${config.VDNS_API_URL}/services/${serviceId}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${idToken}`
    }
  }).then(res => res.json());
};

const getServiceClusters = (idToken, serviceId) => {
  return requestRateLimiter.request(`${config.VDNS_API_URL}/services/${serviceId}/clusters`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${idToken}`
    }
  }).then(res => res.json());
};

const getAllClusters = (idToken, params) => {
  const {
    page = 1,
    limit = 10,
  } = params;

  return requestRateLimiter.request(`${config.VDNS_API_URL}/clusters?page=${page}&limit=${limit}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${idToken}`
    }
  }).then(res => res.json());
};

const updateCluster = (idToken, updatedCluster) => {
  return requestRateLimiter.request(`${config.VDNS_API_URL}/clusters/${updatedCluster.id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`
    },
    body: JSON.stringify(updatedCluster)
  }).then(res => res.json());
};

const updateService = (idToken, updatedService) => {
  return requestRateLimiter.request(`${config.VDNS_API_URL}/services/${updatedService.id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`
    },
    body: JSON.stringify(updatedService)
  }).then(res => res.json());
};

export default {
  isPermitted,
  createRecord,
  getAllRecords,
  getRecord,
  updateRecord,
  deleteRecord,
  getAccountRecords,
  getAllServices,
  getService,
  getServiceClusters,
  getAllClusters,
  updateCluster,
  updateService
};